@if (loading) {
  <div class="cloak" [@enterAnimation]>
    <img src="/assets/img/spinner.gif" />
  </div>
}
@if (display && !loading) {
  <div class="subcontent-map">
    <div class="left-info">
      <app-button
        (clicked)="hideMap()"
        iconLeft="arrow-left"
        color="grey"
        [rounded]="true"
      ></app-button>
      <div [matMenuTriggerFor]="menu">
        <app-button-list-single-select
          icon="calendar"
          [selectedElementPath]="lastHoursHistory[lastHoursIndex].text"
        ></app-button-list-single-select>
      </div>
      <mat-menu class="last-hours-menu" #menu="matMenu">
        <mat-radio-group class="last-hours-group" [(ngModel)]="lastHoursIndex">
          @for (
            lh of lastHoursHistory;
            track lh.durationHours;
            let i = $index
          ) {
            <mat-radio-button
              class="radio-item"
              [value]="i"
              (change)="lastHoursSelected($event.value)"
            >
              {{ lh.text }}
            </mat-radio-button>
          }
        </mat-radio-group>
      </mat-menu>
      <div class="radius">
        <app-toggle-checkbox
          (toggled)="updatePrecisionCircle()"
        ></app-toggle-checkbox>
        <p>{{ "map.precisionCircle" | translate }}</p>
      </div>
      @if (currentItem.tornOff) {
        <app-state-displayer-label labelType="torn"></app-state-displayer-label>
      }
      @if (currentItem.isIncident) {
        <div>
          @if (currentItem.isIncident) {
            <app-state-displayer-label
              (changeTab)="onChangeTab($event)"
              labelType="incident"
              (click)="$event.stopPropagation()"
              [deviceId]="currentItem.deviceId"
            ></app-state-displayer-label>
          }
        </div>
      }
    </div>
    <div class="right-info">
      <app-button
        (clicked)="backToList()"
        iconLeft="go-to-list"
        labelPath="map-detail.list"
        [rounded]="true"
        [underlined]="true"
      ></app-button>
      <app-button
        (clicked)="
          redirectToGmap(
            currentItem.latitudeComputed,
            currentItem.longitudeComputed
          )
        "
        iconLeft="map"
        iconRight="arrow-right"
        labelPath="map-detail.maps"
        [rounded]="true"
        [underlined]="true"
      >
      </app-button>
      <app-export-excel
        class="info separate clickable"
        [type]="exportType"
        [data]="historicalState"
        [containerType]="containerType"
      ></app-export-excel>
    </div>
  </div>
}
@if (display && !loading) {
  <div>
    <app-device-info-window
      [currentState]="currentItem"
      [isAdmin]="isAdmin('IBMAdmin')"
      (previousPos)="previousPos()"
      (nextPos)="nextPos()"
      (firstPos)="firstPos()"
      (lastPos)="lastPos()"
      [isAtHistoryEnd]="isAtEndOfHistory()"
      [isAtHistoryBeginning]="isAtBeginningOfHistory()"
    ></app-device-info-window>
  </div>
}
